import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IRootState, IRootThunkDispatch } from "../../redux/store";
import { OpenLoadingBarThunk } from "../../redux/common/isLoading/thunk";
import {
  axiosAPIWithJson,
  axiosGet,
  axiosPostWithJson,
} from "../../util/axios";
import {
  initBinGroupListThunk,
 
} from "../../redux/BinType/thunk";
import {
  OpenSnackBarWithResultFail,
  OpenSnackBarWithResultSuccess,
} from "../../redux/common/snackBar/thunk";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { Cancel, CheckCircle, EditNote } from "@mui/icons-material";
import { Button, Grid } from "@mui/material";
import { BinGroup } from "../../redux/BinType/state";
import FormDialog from "../common/FormDialog";
import BinGroupForm from "./BinGroupForm";
import {
  checkBinSequenceLimit,
  checkForDuplicateBinSequence,
} from "../../util/form/form";
import { ButtonTextGrid } from "../..";
import AddBinGroupForm from "./AddBinGroupForm";
import { ClearNewBinGroupAction, initGroupNameEnAction, initGroupNameTcAction, initSelectedBinInBinGroupAction } from "../../redux/BinGroup/action";
import moment from "moment";

function BinGroupManagement() {
  const dispatch = useDispatch<IRootThunkDispatch>();
  const [OpenEditDialog, setOpenEditDialog] = useState<boolean>(false);
  const [clickBinGroup, setClickBinGroup] = useState<BinGroup | null>(null);
  const [openAddDialog, setOpenAddDialog] = useState<boolean>(false);

  const { binGroupList } = useSelector(
    (state: IRootState) => state.binListState,
  );
  const { newBinGroup ,selectedBinInBinGroup,originalBinGroup} = useSelector(
    (state: IRootState) => state.binGroupListState,
  );


  
  const dataFetchedRef = useRef(false);

  useEffect(() => {
    const controller = new AbortController();
    if (dataFetchedRef.current) return;
    dataFetchedRef.current = true;

    getData();
    return () => {
      controller.abort();
    };
  }, []);

  const columns: GridColDef[] = [
    { field: "bin_group_id", headerName: "組合編號", flex: 1 },
    { field: "group_name_tc", headerName: "組合名稱(中)", flex: 2 },

    { field: "group_name_en", headerName: "組合名稱(英)", flex: 2 },
    {
      field: "is_active",
      headerName: "狀況",
      flex: 1,
      renderCell: (data) => (
        <div>
          {data.value === 0 ? (
            <Cancel style={{ color: "red" }} />
          ) : (
            <CheckCircle style={{ color: "green" }} />
          )}
        </div>
      ),
    },
    {
      field: "updated_date",
      headerName: "更新時間",
      flex: 1,
      renderCell: (data) => (
        <div>{moment(parseInt(data.value)).format("YYYY-MM-DD HH:mm:ss")}</div>
      ),
    },
    {
      field: "username",
      headerName: "更新者",
      flex: 1,
    },
    {
      field: "action",
      headerName: "更新",
      flex: 1,
      renderCell: (data) => (
        <div>
          <Button
            variant="contained"
            onClick={() => handleClickBinGroup(data.row)}
          >
            <ButtonTextGrid>
              <EditNote />
              <Grid>更新</Grid>
            </ButtonTextGrid>
          </Button>
        </div>
      ),
    },
  ];

  async function handleClickBinGroup(data: BinGroup) {
    setClickBinGroup(data);

    dispatch(OpenLoadingBarThunk(true));
    const result = await axiosGet(`/api/bin/cms/binGroup/${data.bin_group_id}`);
    if (result.data.success) {
 
      setOpenEditDialog(true);
      dispatch(initSelectedBinInBinGroupAction(result.data.binListInGroup));
      dispatch(initGroupNameTcAction(data.group_name_tc));
      dispatch(initGroupNameEnAction(data.group_name_en));
      dispatch(OpenLoadingBarThunk(false));
    } else {
      dispatch(OpenSnackBarWithResultFail("無法下載廁所組合資料"));
           dispatch(OpenLoadingBarThunk(false));
    }
  }

  async function getData() {
    dispatch(OpenLoadingBarThunk(true));
    const result = await axiosGet("/api/bin/cms/binGroup");
    if (result.data.success) {
      dispatch(OpenLoadingBarThunk(false));
      dispatch(initBinGroupListThunk(result.data.binGroupList));
    } else {
      dispatch(OpenSnackBarWithResultFail("無法下載廁所組合資料"));
    }
  }

  function handleDialogClose() {
    // dispatch(ClearSelectedBinThunk());
    setOpenEditDialog(false);
    setOpenAddDialog(false);
  }

  async function handleSubmitBin() {
    const duplicateBinSequence = checkForDuplicateBinSequence(
      selectedBinInBinGroup!,
    );
    if (duplicateBinSequence.length > 0) {
      dispatch(
        OpenSnackBarWithResultFail(`次序 ${duplicateBinSequence} 重覆了`),
      );
      return;
    }

    const checkBinSequnceResult = checkBinSequenceLimit(
      selectedBinInBinGroup!,
      selectedBinInBinGroup!.length,
    );

    if (checkBinSequnceResult) {
      dispatch(OpenSnackBarWithResultFail(checkBinSequnceResult));
      return;
    }

    const data = {
      group_name_tc:newBinGroup.group_name_tc,
      group_name_en:newBinGroup.group_name_en,
      bin_group_id:clickBinGroup?.bin_group_id,
      is_active:newBinGroup.is_active,
      selectedBinInBinGroup,
      originalBinGroup
    }

    dispatch(OpenLoadingBarThunk(true));
    const result = await axiosAPIWithJson.put(
      `/api/bin/cms/binGroup`,
      data,
    );

    if (result.data.success) {
      
      dispatch(OpenSnackBarWithResultSuccess(`你已成功更改了組合：${data.group_name_tc}`));
      setOpenEditDialog(false);
      await getData();
      dispatch(OpenLoadingBarThunk(false));
    } else {
      dispatch(OpenLoadingBarThunk(false));
      dispatch(OpenSnackBarWithResultFail(result.data.message));
    }
  }

  function handleEditBinBtn() {
    setOpenAddDialog(true);
  }

  async function handleSubmitNewBinGroup() {
    if (!newBinGroup.group_name_tc) {
      dispatch(OpenSnackBarWithResultFail("你未有填寫中文組合名稱"));
      return;
    }
    dispatch(OpenLoadingBarThunk(true));

    const result = await axiosPostWithJson(
      `/api/bin/cms/binGroup`,
      newBinGroup,
    );

    if (result.data.success) {
      dispatch(OpenLoadingBarThunk(false));
      dispatch(OpenSnackBarWithResultSuccess(result.data.message));
      dispatch(ClearNewBinGroupAction());
      setOpenAddDialog(false);
      await getData();
    } else {
      dispatch(OpenLoadingBarThunk(false));
      dispatch(OpenSnackBarWithResultFail(result.data.message));
    }
  }

  return (
    <Grid>
      <Grid style={{ display: "flex", justifyContent: "space-between" }}>
        <Button variant="contained" onClick={() => handleEditBinBtn()}>
          <ButtonTextGrid>新增組合</ButtonTextGrid>
        </Button>
      </Grid>
      <div style={{ height: "900px", width: "100%" }}>
        <DataGrid
          rows={binGroupList || []}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 30 },
            },
          }}
          pageSizeOptions={[5, 10]}
          checkboxSelection
          getRowId={(row) => row.bin_group_id}
        />
      </div>


{clickBinGroup && (
   <FormDialog
        title={`更改組合 - ${clickBinGroup.group_name_tc}`}
        open={OpenEditDialog}
        handleClose={handleDialogClose}
        size='xl'
        handleSubmit={handleSubmitBin}
      >
        <BinGroupForm />
      </FormDialog>

)}
   

      <FormDialog
        title="新增組合內容"
        open={openAddDialog}
        handleClose={handleDialogClose}
        handleSubmit={handleSubmitNewBinGroup}
        size='xl'
      >
        <AddBinGroupForm />
      </FormDialog>
    </Grid>
  );
}

export default BinGroupManagement;
